module.exports = {
  en: {
    'metaDescription': 'Static site templates of Ron.gr',
    'Motto': 'Pick a template for your website, quick and easy!',
    'WebsiteFormHeader': 'You are about to create your new website!',
    'WebsiteFormParagraph': 'Fill in your contact details and we will contact you shortly.',
  },
  el: {
    'metaDescription': 'Έτοιμες προτάσεις για προσχέδια στατικών site της Ron.gr',
    'Template': 'Προσχέδιο',
    'Welcome': 'Καλώς ήρθατε',
    'to JAM.ron': 'στο JAM.ron',
    'Motto': 'Διαλέξτε προσχέδιο για την ιστοσελίδα σας, γρήγορα και απλά!',
    'Request it': 'Ζητήστε το',
    'Selected template image': 'Εικόνα επιλεγμένου προσχεδίου',
    'Website request form': 'Φόρμα ενδιαφέροντος ιστοσελίδας',
    'WebsiteFormHeader': 'Βρίσκεστε ένα βήμα πριν την δημιουργία της ιστοσελίδας σας!',
    'WebsiteFormParagraph': 'Συμπληρώστε τα στοιχεία σας και θα επικοινωνήσουμε άμεσα μαζί σας για να ξεκινήσουμε τη νέα σας ιστοσελίδα.',
    'Cancel': 'Ακύρωση',
    'Submit': 'Αποστολή',
    'Name': 'Όνομα',
    'Description': 'Περιγραφή',
    'Your email addess': 'Η ηλεκτρονική σας διεύθυνση',
    'Your full name': 'Το ονοματεπώνυμο σας',
    'A few words about your project': 'Λίγα λόγια για το project σας',
    'Message NOT delivered': 'Το μήνυμα ΔΕΝ παραδόθηκε',
    'Message was submitted': 'Το μήνυμα παραδόθηκε',
    'Thank you!': 'Σας ευχαριστούμε!',
  },
}



// WEBPACK FOOTER //
// ./src/i18n/translations.js